import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import RenderIcons from "../../../Assets/css/_icons/partner_icon/RenderIcons";
import { ezsServiceIds, idfServiceIds } from "../../../config/UserServicesList";
import { ApplicationState } from "../../../store";
import * as CreditActions from "../../../store/credit/actions";
import { useAreServicesActive, getActiveServiceCode } from "../../../util/CommonServices";
import { useBureauPermission, fetchCreditData } from "../../../util/credit";
import { getFormattedDate } from "../../../util/dateFormatting";
import * as httpClient from "../../../util/httpClient";
import i18nService from "../../../util/Internationalization/i18n/i18n";
import Tab from "../../common/Tab/Tab";
import CreditHistory from "./CreditHistory";
import CreditSummary from "./CreditSummary";
import DailyCreditSummary from "./DailyCreditSummary";
import HistoricalReport from "./HistoricalReport";
import PurchaseCreditReport from "./PurchaseCreditReport";
import { useTranslation } from "react-i18next";
import { RECEIVE_ONETIME_CREDIT, RECEIVE_CREDIT_DATA } from "../../../store/credit/types";

function Iframe(props: any) {
    return <div dangerouslySetInnerHTML={{ __html: props.iframe ? props.iframe : "" }} />;
}

interface ICreditHistory {
    alertID: number;
    alertCategory: string;
    displayName: string;
    alertDate: string;
    serviceCode: string;
    recentCreditReport?: any;
}

const CreditReport = (props: any) => {
    const initialCreditHistory: ICreditHistory[] = [];
    const dispatch = useDispatch();
    const { t: tLang } = useTranslation();
    const bureauPermission = useBureauPermission();
    const [iframeURl, setIframeURl] = useState("");
    const [showHistoricalReport, setShowHistoricalReport] = useState(false);
    const [selectedReportId, setSelectedReportId] = useState("");
    const [selectedReportServiceCode, setSelectedReportServiceCode] = useState("");
    const [view, setView] = useState("3b");
    const [purchasedReport, setPurchasedReport] = useState(props.purchasedReport ? props.purchasedReport : false);
    const [purchasedReportData, setPurchasedReportData] = useState(props.purchasedReportData);
    const [purchasedReportLoading, setPurchasedReportLoading] = useState(false);
    const [creditHistory, setCreditHistory] = useState(initialCreditHistory);
    const [isCreditHistoryLoading, setIsCreditHistoryLoading] = useState(false);
    const [failedBuraus, setFailedBuraus] = useState([]);
    const isTUUser = useSelector((state: ApplicationState) => state.loggedInUser && state.loggedInUser.userInfo?.isTUUser);
    let isLoading = useSelector((state: ApplicationState) => {
        if (purchasedReport) {
            return purchasedReportLoading;
        } else {
            return state.creditState?.isLoading;
        }
    });
    const hasError = useSelector((state: ApplicationState) => {
        return state.creditState.hasError;
    });
    const isCCMTUser = useSelector((state: ApplicationState) =>
        state.loggedInUser && state.loggedInUser.userInfo ? state.loggedInUser.userInfo.isCCMTUser : false
    );
    const hasPurchaseCreditReport = useSelector((state: ApplicationState) => state.loggedInUser && state.loggedInUser.hasPurchaseCreditReport);
    const isPurchaseDisabled = useSelector((state: ApplicationState) => {
        return state.creditHistoryData.isPurchaseDisabled;
    });
    const isOneTimeOnlyReport = useSelector((state: ApplicationState) => state.creditHistoryData && state.creditHistoryData.isOneTimeOnlyReport);

    const l3Status = useSelector((state: ApplicationState) =>
        state.csidUserStatusState && state.csidUserStatusState.csidUserStatus ? state.csidUserStatusState.csidUserStatus : null
    );

    let defaultTabNumber = "5";
    const [selectedTab, setSelectedTab] = useState(defaultTabNumber);

    const ids = [
        ezsServiceIds.experianCreditReport,
        ezsServiceIds.experianCreditReportwithScore,
        ezsServiceIds.experianAnnualCreditReportWithScore,
        ezsServiceIds.creditReportForEachOf3Bureaus,
        ezsServiceIds.creditReportForEachOf3BureausWithScore,
        ezsServiceIds.experianAnnualCreditReportForEachOf3BureausWithScore,
        ezsServiceIds.oneBureauQuarterlyCreditReport,
        ezsServiceIds.oneBureauMonthlyCreditReport,
        ezsServiceIds.transCreditReport,
        idfServiceIds.threeBureauCreditReports,
        idfServiceIds.transUnionCreditReport,
        ezsServiceIds.tuCreditReport,
        ezsServiceIds.tuDailyCreditReport,
        ezsServiceIds.tuMonthlyCreditReport,
        ezsServiceIds.tuQuarterlyCreditReport,
        ezsServiceIds.tuAnnualCreditReport,
        ezsServiceIds.tuCreditReportForEachOf3Bureaus,
        ezsServiceIds.tuMonthlyCreditReportForEachOf3Bureaus,
        ezsServiceIds.tuQuarterlyCreditReportForEachOf3Bureaus,
        ezsServiceIds.tuAnnualCreditReportForEachOf3Bureaus,
        ezsServiceIds.tuCreditReportWithScore,
        ezsServiceIds.tuDailyCreditReportWithScore,
        ezsServiceIds.tuMonthlyCreditReportWithScore,
        ezsServiceIds.tuQuarterlyCreditReportWithScore,
        ezsServiceIds.tuAnnualCreditReportWithScore,
        ezsServiceIds.tuCreditReportForEachOf3BureausWithScore,
        ezsServiceIds.tuMonthlyCreditReportForEachOf3BureausWithScore,
        ezsServiceIds.tuQuarterlyCreditReportForEachOf3BureausWithScore,
        ezsServiceIds.tuAnnualCreditReportForEachOf3BureausWithScore,
        ezsServiceIds.tuCanadaMonthlyCreditReportWithScore,
        ezsServiceIds.tuCanadaQuarterlyCreditReportWithScore,
        ezsServiceIds.tuCanadaAnnualCreditReportWithScore,
        ezsServiceIds.tuCanadaOneTimeCreditReportWithScore,
        ezsServiceIds.tuOneTimeCreditReportWithScore,
        ezsServiceIds.tuCanadaQuarterlyCreditReport,
    ];

    const transUnionIds = [
        ezsServiceIds.transCreditReport,
        idfServiceIds.transUnionCreditReport,
        ezsServiceIds.tuCreditReport,
        ezsServiceIds.tuDailyCreditReport,
        ezsServiceIds.tuMonthlyCreditReport,
        ezsServiceIds.tuQuarterlyCreditReport,
        ezsServiceIds.tuAnnualCreditReport,
        ezsServiceIds.tuCreditReportForEachOf3Bureaus,
        ezsServiceIds.tuMonthlyCreditReportForEachOf3Bureaus,
        ezsServiceIds.tuQuarterlyCreditReportForEachOf3Bureaus,
        ezsServiceIds.tuAnnualCreditReportForEachOf3Bureaus,
        ezsServiceIds.tuCreditReportWithScore,
        ezsServiceIds.tuDailyCreditReportWithScore,
        ezsServiceIds.tuMonthlyCreditReportWithScore,
        ezsServiceIds.tuQuarterlyCreditReportWithScore,
        ezsServiceIds.tuAnnualCreditReportWithScore,
        ezsServiceIds.tuCreditReportForEachOf3BureausWithScore,
        ezsServiceIds.tuMonthlyCreditReportForEachOf3BureausWithScore,
        ezsServiceIds.tuQuarterlyCreditReportForEachOf3BureausWithScore,
        ezsServiceIds.tuAnnualCreditReportForEachOf3BureausWithScore,
        ezsServiceIds.tuCanadaMonthlyCreditReportWithScore,
        ezsServiceIds.tuCanadaQuarterlyCreditReportWithScore,
        ezsServiceIds.tuCanadaAnnualCreditReportWithScore,
        ezsServiceIds.tuCanadaOneTimeCreditReportWithScore,
        ezsServiceIds.tuOneTimeCreditReportWithScore,
        ezsServiceIds.tuCanadaQuarterlyCreditReport,
    ];

    const tuOneTimeCreditServiceIds = [
        ezsServiceIds.tuCreditReportWithScore,
        ezsServiceIds.tuCreditReportForEachOf3BureausWithScore,
        ezsServiceIds.tuCreditReportForEachOf3Bureaus,
        ezsServiceIds.tuCreditReport,
    ];
    const isCreditReportActive = useAreServicesActive(ids);
    const isTransUnionCreditReportActive = useAreServicesActive(transUnionIds) || hasPurchaseCreditReport;

    const threeBureauIds = [
        ezsServiceIds.tuMonthlyCreditReportForEachOf3Bureaus,
        ezsServiceIds.tuMonthlyCreditReportForEachOf3BureausWithScore,
        ezsServiceIds.tuQuarterlyCreditReportForEachOf3Bureaus,
        ezsServiceIds.tuQuarterlyCreditReportForEachOf3BureausWithScore,
        ezsServiceIds.tuAnnualCreditReportForEachOf3Bureaus,
        ezsServiceIds.tuAnnualCreditReportForEachOf3BureausWithScore,
    ];

    const dailyRefreshableCreditServiceIds = [ezsServiceIds.tuDailyCreditReportWithScore, ezsServiceIds.tuDailyCreditReport];
    const isDailyRefreshableCreditServiceActive = useAreServicesActive(dailyRefreshableCreditServiceIds);

    const hasCombinationService = useAreServicesActive(threeBureauIds) && isDailyRefreshableCreditServiceActive ? true : false;
    const dailyServiceCode = getActiveServiceCode(dailyRefreshableCreditServiceIds);

    const requestCreditHistory = (forcefullyRefresh: boolean) => dispatch(CreditActions.actionCreators.requestCreditHistory(forcefullyRefresh));
    const scoreOnlyIds = [
        idfServiceIds.creditScoreMonitoring,
        idfServiceIds.threeBureauCreditScores,
        idfServiceIds.transUnionCreditScore,
        ezsServiceIds.quarterlyCreditScore,
        ezsServiceIds.tuDailyCreditScore,
        ezsServiceIds.tuMonthlyCreditScore,
        ezsServiceIds.tuQuarterlyCreditScore,
        ezsServiceIds.tuAnnualCreditScore,
        ezsServiceIds.tuCanadaCreditScore,
        ezsServiceIds.monthlyCreditScore,
        ezsServiceIds.tuCreditScoreTracker,
        ezsServiceIds.tuCanadaCreditScoreTracker,
        ezsServiceIds.expMonthlyCreditScoreTracker,
    ];
    const hasCreditScoreOnlyService = useAreServicesActive(scoreOnlyIds);

    const prioritizedServiceCode = useSelector((state: ApplicationState) => {
        if (state.creditHistoryData.isOneTimeOnlyScore && !hasCreditScoreOnlyService && !state.creditHistoryData.isOneTimeReportLatest) {
            return state.creditHistoryData.oneTimeScoreServiceCode;
        } else if (state.creditHistoryData.isOneTimeOnlyReport) {
            return state.creditHistoryData.oneTimeReportServiceCode;
        } else {
            return "";
        }
    });

    const requestCreditData = () => dispatch(CreditActions.actionCreators.requestCreditData(false, bureauPermission, prioritizedServiceCode));
    const requestDailyCreditScore = () => dispatch(CreditActions.actionCreators.requestDailyCredit(false, dailyServiceCode));

    const ensureDataFetched = () => {
        if (!purchasedReport) {
            requestCreditData();
        }
        if (hasCombinationService) {
            requestDailyCreditScore();
        }
    };

    let creditReport = useSelector((state: ApplicationState) => {
        if (purchasedReport) {
            return purchasedReportData;
        } else if (state.creditState.creditData && state.creditState.creditData.length > 0) {
            let scoreData = fetchCreditData(state.creditState.creditData);
            return scoreData;
        } else {
            return null;
        }
    });

    let creditReportState = useSelector((state: ApplicationState) => {
        return state.creditState.creditData;
    });

    const reportServiceCode = creditReport && creditReport["service-code"] ? creditReport["service-code"] : "";
    const isOneTimeReport = tuOneTimeCreditServiceIds.includes(reportServiceCode);

    let dailyCreditReport = useSelector((state: ApplicationState) => {
        return state.dailyCreditScoreData.dailyCreditData;
    });

    const partnerPhoneNumber: string = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.phoneNumber
            ? state.configurationState.configuration.partnerConfig.phoneNumber
            : ""
    );

    const requestReportData = () => {
        if (l3Status?.isIDFUser === false) {
            const requestBody = {};
            if (selectedTab === "5") {
                // this does not apply to one time reports since they are from TU
                if (!isTUUser) {
                    httpClient.sendRequest("POST", `api/credit-monitoring/getCreditReportData`, requestBody).then((data: any) => {
                        setIframeURl(data.creditReportIframeUrl);
                        const iframe = document.getElementById("credit-report-iframe");
                        const loader = document.getElementById("report-iframe-loader");

                        if (iframe != null) {
                            iframe.hidden = true;
                            iframe.addEventListener("load", function (e) {
                                if (loader != null) {
                                    loader.hidden = true;
                                    iframe.hidden = false;
                                }
                            });
                        }
                    });
                }
            } else if (selectedTab === "6") {
                setIsCreditHistoryLoading(true);
                httpClient.sendRequest("POST", `api/credit-monitoring/GetCreditHistory`, {}).then((data: any) => {
                    setIsCreditHistoryLoading(false);
                    setCreditHistory(data);
                });
            }
        }
    };

    const creditReportIframe = {
        source:
            '<iframe id="credit-report-iframe" width="100%" height="2000px" scrolling="yes" frameborder="no" src=' +
            iframeURl +
            ' style="width:100%; height:2000px; border:0; border-radius: 4px; overflow:scroll;"></iframe>',
    };

    const changeTab = (tabIndex: string, purchaseReportTabChange?: boolean, selectedServiceCode?: string) => {
        if (purchaseReportTabChange) {
            setPurchasedReport(true);
            setPurchasedReportLoading(true);
            // fetch the report, but don't add it to the store, this way we only see it the one time
            const requestBody = {
                "service-code": selectedServiceCode ? selectedServiceCode : "",
                action: "PURCHASE_ONETIME",
            };
            httpClient
                .sendRequest("POST", `api/credit-monitoring/getCreditScoreData`, requestBody)
                .then((data) => {
                    requestCreditHistory(true);
                    setPurchasedReportData(data);
                    // add this data to the store, so that we can use it on the score page
                    dispatch({ type: RECEIVE_ONETIME_CREDIT, oneTimeCreditData: data, purchasedReport: true, pageViewScore: false });

                    // save state if its one time report only
                    if (isOneTimeOnlyReport) {
                        let creditData = creditReportState;
                        creditData.unshift(data);
                        dispatch({ type: RECEIVE_CREDIT_DATA, creditData: creditData });
                    }
                    setPurchasedReportLoading(false);
                })
                .catch(function (error) {
                    console.log(error);
                    setPurchasedReportLoading(false);
                });
        }
        setSelectedTab(tabIndex);
    };

    const toggleCreditNav = (id: string) => {
        let container = document.getElementById(id);

        if (container) {
            if (container.style.display !== "none") {
                container.style.display = "none";
                container.setAttribute("aria-hidden", "true");
            } else {
                container.style.display = "block";
                container.setAttribute("aria-hidden", "false");
            }
        }
    };

    const openReport = (alertId: string, serviceCode: string) => {
        //added temporary first If condition for CSID migrated user
        if (isTUUser && isCCMTUser && alertId && alertId.length < 30) {
            const requestBody = {
                "alert-id": alertId,
                "service-code": serviceCode || "",
            };
            httpClient.sendRequest("POST", `api/credit-monitoring/getCreditReportData`, requestBody).then((data: any) => {
                var options = [
                    "toolbar=no,location=no,status=yes,resizable=yes,scrollbars=yes",
                    "height=" + window.screen.height,
                    "width=" + window.screen.width,
                ].join(",");

                //added  condition for CSID deactivated user
                if (data.creditReportIframeUrl === "notfound") {
                    setSelectedReportId(alertId);
                    setSelectedReportServiceCode(serviceCode);
                    setShowHistoricalReport(true);
                    toggleCreditNav("credit-tabs");
                } else {
                    var iframe =
                        "<html><head><style>body, html {width: 100%; height: 100%; margin: 0; padding: 0}</style></head><body><iframe src=" +
                        data.creditReportIframeUrl +
                        ' style="height:calc(100% - 4px); width:calc(100% - 4px)"></iframe></html></body>';
                    var newWindow = window.open("", "Credit Report", options);

                    newWindow?.document.write(iframe);
                }
            });
            return false;
        }

        if (isTUUser) {
            setSelectedReportId(alertId);
            setSelectedReportServiceCode(serviceCode);
            setShowHistoricalReport(true);
            toggleCreditNav("credit-tabs");
        } else {
            httpClient.sendRequest("POST", `api/credit-monitoring/getCreditReportData`, { "alert-id": alertId }).then((data: any) => {
                var options = [
                    "toolbar=no,location=no,status=yes,resizable=yes,scrollbars=yes",
                    "height=" + window.screen.height,
                    "width=" + window.screen.width,
                ].join(",");
                var iframe =
                    "<html><head><style>body, html {width: 100%; height: 100%; margin: 0; padding: 0}</style></head><body><iframe src=" +
                    data.creditReportIframeUrl +
                    ' style="height:calc(100% - 4px); width:calc(100% - 4px)"></iframe></html></body>';
                var newWindow = window.open("", "Credit Report", options);
                newWindow?.document.write(iframe);
            });
            return false;
        }
    };

    const closeHistoricalReport = () => {
        setShowHistoricalReport(false);
        toggleCreditNav("credit-tabs");
    };

    const toggleReportView = () => {
        setView(view === "3b" ? "daily" : "3b");
    };

    useEffect(() => {
        const initialUrl = encodeURI(window.location.origin + "/app/credit/score");
        sessionStorage.setItem("initialUrl", initialUrl);
        if (creditReportState?.[0]?.creditReport?.failedBureaus) {
            setFailedBuraus(creditReportState[0].creditReport.failedBureaus);
        } else if (dailyCreditReport?.creditReport?.failedBureaus) {
            setFailedBuraus(dailyCreditReport.creditReport.failedBureaus);
        }
    }, [creditReportState, dailyCreditReport]);

    const getFailedBuraus = () => {
        let failedBurau = '';
        if (failedBuraus.length === 1) {
            failedBurau += failedBuraus[0];
        } else if (failedBuraus.length === 2) {
            failedBurau += failedBuraus[0] + ' and ' + failedBuraus[1];
        } else if (failedBuraus.length === 3) {
            failedBurau += failedBuraus[0] + ', ' + failedBuraus[1] + ' and ' + failedBuraus[2];
        }
        return failedBurau;
    }

    useEffect(ensureDataFetched);

    useEffect(requestReportData, [creditReport, selectedTab, purchasedReport]);

    const [showBNPLBanner, setShowBNPLBanner] = useState(false);

    const isCountryUS = useSelector((state: ApplicationState) =>
        state.myAccountServiceState && state.myAccountServiceState._unifiedAccountInfo?.country
            ? state.myAccountServiceState._unifiedAccountInfo.country === 'US'
                ? true
                : false
            : false
    );

    useEffect(() => {
        if ((isCreditReportActive || hasCreditScoreOnlyService || isTransUnionCreditReportActive) && isCountryUS) {
            setShowBNPLBanner(true);
        }
        else {
            setShowBNPLBanner(false);
        }
    }, []);

    const closeBNPLBanner = (): any => {
        setShowBNPLBanner(false);
    };

    return (
        <React.Fragment>
            {isCreditReportActive === true || purchasedReport || props.recentCreditReport ? (
                <div className={isLoading ? "loading" : ""}>
                    {showHistoricalReport ? (
                        <HistoricalReport
                            selectedReportId={selectedReportId}
                            selectedReportServiceCode={selectedReportServiceCode}
                            isTUUser={isTUUser}
                            closeReport={closeHistoricalReport}
                            hasCombinationService={hasCombinationService}
                            setCreditHistory={setCreditHistory}
                        />
                    ) : l3Status?.isIDFUser === false ? (
                        <React.Fragment>
                            <Tab tabId="credit-report-sub-items">
                                {creditReport && (
                                    <li
                                        className="tab-item"
                                        role="menuitem"
                                        onClick={() => changeTab("5")}
                                        onKeyPress={() => changeTab("5")}
                                        id={"credit-report-latest-tab"}
                                        aria-label="Latest Credit Report"
                                    >
                                        <Link to="#" className={"btn-default btn-tab " + (selectedTab === "5" ? "tab-active" : "")}>
                                            <span className="btn-text">{tLang("credit.creditReport.tabs.latestCreditReport")}</span>
                                        </Link>
                                    </li>
                                )}
                                <li
                                    className="tab-item"
                                    role="menuitem"
                                    onClick={() => changeTab("6")}
                                    onKeyPress={() => changeTab("6")}
                                    id={"credit-report-historical-tab"}
                                    aria-label="All Credit Reports"
                                >
                                    <Link to="#" className={"btn-default btn-tab " + (selectedTab === "6" ? "tab-active" : "")}>
                                        <span className="btn-text">{tLang("credit.creditReport.tabs.allCreditReport")}</span>
                                    </Link>
                                </li>

                                {hasPurchaseCreditReport && (
                                    <li className="tab-item" role="menuitem" onClick={() => changeTab("7")} onKeyPress={() => changeTab("7")} aria-label="Purchase Credit Report">
                                        <Link to="#" className={"btn-default btn-tab " + (selectedTab === "7" ? "tab-active" : "")}>
                                            <span className="btn-text">Purchase Credit Report</span>
                                        </Link>
                                    </li>
                                )}
                                </Tab>
                            {failedBuraus.length > 0 ? (
                                <div className="box d-flex flex-row" style={{ margin: "8px", marginBottom: "5px" }}>
                                    <div className="col-10">
                                        <div className="sys-msg-content">
                                            <span className="error-icon">
                                                <em className="las la-exclamation-triangle" style={{ fontSize: "1.2rem", color: "#ab170d" }}></em>&nbsp;
                                                <p style={{ fontWeight: "600", display: "inline" }}>{tLang("credit.creditReport.bannerMessage.title")}</p>
                                            </span>
                                            <p>
                                                {tLang("credit.creditReport.bannerMessage.msg1")}{" "}
                                                {getFailedBuraus()}{" "}
                                                {tLang("credit.creditReport.bannerMessage.msg2")}{" "}
                                                <span style={{ fontWeight: "600" }}>{tLang("credit.creditReport.bannerMessage.msg3")}</span>{" "}
                                                {tLang("credit.creditReport.bannerMessage.msg4")}{" "}
                                                {partnerPhoneNumber}.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            ) : null}
                            {showBNPLBanner && (
                                <div className="box d-flex flex-row" style={{ margin: "8px", marginBottom: "5px" }}>
                                    <div className="col-10">
                                        <p><strong>Credit Report Information: </strong>
                                            TransUnion is now including some buy now, pay later (BNPL) installment loans on credit reports.&nbsp;
                                            <a className="default_link" target="_blank" href="https://www.transunion.com/Buy-Now-Pay-Later"> Learn More...</a>
                                        </p>
                                    </div>
                                    <div className="col-2" style={{ marginLeft: "5px" }}>
                                        <span onClick={closeBNPLBanner} style={{ cursor: "pointer" }}>
                                            <em className="las la la-close la-1x"></em>
                                        </span>
                                    </div>
                                </div>
                            )}

                            <div className="row" id="content">
                                <div className="col-xs">
                                    {selectedTab === "5" ? (
                                        isTUUser ? (
                                            <div className="row" id="content">
                                                <div className="col-xs">
                                                    {hasCombinationService ? (
                                                        view === "3b" ? (
                                                            <CreditSummary
                                                                data={creditReport}
                                                                isTUUser={isTUUser}
                                                                view={view}
                                                                toggleReportView={toggleReportView}
                                                                isOneTimeReport={isOneTimeReport}
                                                            />
                                                        ) : (
                                                            <DailyCreditSummary
                                                                data={dailyCreditReport}
                                                                isTUUser={isTUUser}
                                                                view={view}
                                                                toggleReportView={toggleReportView}
                                                            />
                                                        )
                                                    ) : (
                                                        <CreditSummary
                                                            data={creditReport}
                                                            isTUUser={isTUUser}
                                                            view={view}
                                                            toggleReportView={toggleReportView}
                                                            isOneTimeReport={isOneTimeReport}
                                                        />
                                                    )}
                                                    <CreditHistory data={creditReport} />
                                                </div>
                                            </div>
                                        ) : (
                                            <React.Fragment>
                                                {iframeURl == null ? (
                                                    <React.Fragment>
                                                        <div className="box">
                                                            <div className="box-content">You currently have no credit reports to review.</div>
                                                        </div>
                                                    </React.Fragment>
                                                ) : (
                                                    <div id="report-iframe-loader" className="box loading"></div>
                                                )}
                                                {iframeURl != null && iframeURl !== "" ? <Iframe id iframe={creditReportIframe["source"]} /> : null}
                                            </React.Fragment>
                                        )
                                    ) : null}

                                    {selectedTab === "6" ? (
                                        <div className="box">
                                            <div className="box-content">
                                                {isCreditHistoryLoading ? (
                                                    <div className="box loading"></div>
                                                ) : creditHistory == null || creditHistory.length === 0 ? (
                                                    <React.Fragment>You currently have no credit reports to review.</React.Fragment>
                                                ) : (
                                                    <React.Fragment>
                                                        <div className="table-container scroll">
                                                            <div className="ant-table">
                                                                {isTransUnionCreditReportActive && isTUUser && (
                                                                    <p className="tu-note">
                                                                        <strong>{tLang("resourcesSection.allReport.label.noteTitle")}</strong>
                                                                        {tLang("resourcesSection.allReport.label.note")}
                                                                    </p>
                                                                )}
                                                                <div className="ant-table-container">
                                                                    <div className="ant-table-content">
                                                                        <table style={{ tableLayout: "auto" }}>
                                                                            <thead className="ant-table-thead">
                                                                                <tr>
                                                                                    <th className="ant-table-cell">
                                                                                        {tLang("resourcesSection.allReport.label.dateReceived")}
                                                                                    </th>
                                                                                    <th className="ant-table-cell">
                                                                                        {tLang("resourcesSection.allReport.label.type")}
                                                                                    </th>
                                                                                    <th className="ant-table-cell">
                                                                                        {tLang("resourcesSection.allReport.label.details")}
                                                                                    </th>
                                                                                </tr>
                                                                            </thead>
                                                                            <tbody className="ant-table-tbody">
                                                                                <React.Fragment>
                                                                                    {creditHistory &&
                                                                                        creditHistory.map((history, index: number) => {
                                                                                            return (
                                                                                                <tr className="ant-table-row" key={"history-" + history.alertID}>
                                                                                                    <td className="ant-table-cell">
                                                                                                        {history.alertDate &&
                                                                                                            getFormattedDate(
                                                                                                                i18nService.get("Country"),
                                                                                                                history.alertDate
                                                                                                            )}
                                                                                                    </td>
                                                                                                    <td className="ant-table-cell">
                                                                                                        {history.displayName !== null
                                                                                                            ? history.displayName === "Monthly Credit Report & CreditVision Score"
                                                                                                                ? tLang("resourcesSection.allReport.type.monthlyCreditReportLabel")
                                                                                                                : history.displayName
                                                                                                            : "Credit Report"}{" "}
                                                                                                    </td>
                                                                                                    <td className="ant-table-cell">
                                                                                                        <a
                                                                                                            href="/"
                                                                                                            className="default_link"
                                                                                                            onClick={(e) => {
                                                                                                                e.preventDefault();
                                                                                                                openReport(
                                                                                                                    history.alertID.toString(),
                                                                                                                    history.serviceCode
                                                                                                                );
                                                                                                            }}
                                                                                                        >
                                                                                                            {tLang("resourcesSection.allReport.label.view")}
                                                                                                        </a>
                                                                                                    </td>
                                                                                                </tr>
                                                                                            );
                                                                                        })}
                                                                                </React.Fragment>
                                                                            </tbody>
                                                                        </table>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </React.Fragment>
                                                )}
                                            </div>
                                        </div>
                                    ) : null}
                                    {selectedTab === "7" ? <PurchaseCreditReport changeTabCallback={changeTab} purchaseDisabled={isPurchaseDisabled} /> : null}
                                </div>
                            </div>
                        </React.Fragment>
                    ) : creditReport != null && creditReport.IsIDFUser === true ? (
                                <div>
                                    {failedBuraus.length > 0 ? (
                                        <div className="box d-flex flex-row" style={{ margin: "8px", marginBottom: "5px" }}>
                                            <div className="col-10">
                                                <div className="sys-msg-content">
                                                    <span className="error-icon">
                                                        <em className="las la-exclamation-triangle" style={{ fontSize: "1.2rem", color: "#ab170d" }}></em>&nbsp;
                                                        <p style={{ fontWeight: "600", display: "inline" }}>{tLang("credit.creditReport.bannerMessage.title")}</p>
                                                    </span>
                                                    <p>
                                                        {tLang("credit.creditReport.bannerMessage.msg1")}{" "}
                                                        {getFailedBuraus()}{" "}
                                                        {tLang("credit.creditReport.bannerMessage.msg2")}{" "}
                                                        <span style={{ fontWeight: "600" }}>{tLang("credit.creditReport.bannerMessage.msg3")}</span>{" "}
                                                        {tLang("credit.creditReport.bannerMessage.msg4")}{" "}
                                                        {partnerPhoneNumber}.
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    ) : null}
                            {showBNPLBanner && (
                                <div className="box d-flex flex-row" style={{ margin: "8px", marginBottom: "5px" }}>
                                    <div className="col-10">
                                        <p><strong>Credit Report Information: </strong>
                                            TransUnion is now including some buy now, pay later (BNPL) installment loans on credit reports.&nbsp;
                                            <a className="default_link" target="_blank" href="https://www.transunion.com/Buy-Now-Pay-Later"> Learn More...</a>
                                        </p>
                                    </div>
                                    <div className="col-2" style={{ marginLeft: "5px" }}>
                                        <span onClick={closeBNPLBanner} style={{ cursor: "pointer" }}>
                                            <em className="las la la-close la-1x"></em>
                                        </span>
                                    </div>
                                </div>
                            )}
                            <div className="row" id="content">
                                <div className="col-xs">
                                    {hasCombinationService ? (
                                        view === "3b" ? (
                                            <CreditSummary
                                                data={creditReport}
                                                isTUUser={isTUUser}
                                                view={view}
                                                toggleReportView={toggleReportView}
                                                isOneTimeReport={isOneTimeReport}
                                            />
                                        ) : (
                                            <DailyCreditSummary data={dailyCreditReport} isTUUser={isTUUser} view={view} toggleReportView={toggleReportView} />
                                        )
                                    ) : (
                                        <CreditSummary
                                            data={creditReport}
                                            isTUUser={isTUUser}
                                            view={view}
                                            toggleReportView={toggleReportView}
                                            isOneTimeReport={isOneTimeReport}
                                        />
                                    )}
                                    <CreditHistory data={creditReport} />
                                </div>
                            </div>
                        </div>
                    ) : hasError ? (
                        <div className="col-xs-12">
                            <div className="box">
                                <div className="box offset-padding">
                                    <div className="box-header">
                                        <div className="box-title-container">
                                            <div className="box-title-icon dashboard-alert-icon" aria-hidden="true">
                                                <em className="las la-exclamation-triangle"></em>
                                            </div>
                                            <div className="box-title-text has-actions">
                                                <h2 className="box-title">{tLang("credit.authErrorHeader")}</h2>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="box-content">
                                        <p>
                                            {tLang("credit.authErrorMessage")}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ) : (
                        <></>
                    )}
                </div>
            ) : (
                <>
                    <div className="row" id="content">
                        <div className="col-xs-12">
                            <div className="box">
                                <div className="text-align-center">
                                    <div className="color-alert msg-small margin-top-xs">
                                        <RenderIcons iconName="info-circle" /> This feature is not included in your subscription.
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            )}
        </React.Fragment>
    );
};

export default CreditReport;
